
(function () {
    'use strict';
    class MeetingLocation extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AnalyticsService) {
            super($scope, $injector);
            this.__objectType = 'MeetingLocation';

            this.AnalyticsService = AnalyticsService;
        }

        onLocationFieldChange() {
            this.AnalyticsService.track(this, this.analyticsEvent, {source: this.analyticsEventSource});
            return this.onLocationChange({location: this.location});
        }

        onGoogleLocationChange(geocodeResult) {
            this.location = geocodeResult.formatted_address.includes(geocodeResult.name) ?
                geocodeResult.formatted_address :
                `${geocodeResult.name}, ${geocodeResult.formatted_address}`;
            this.onLocationFieldChange();
        }
    }

    Components.MeetingLocation = {
        bindings: {
            placeholder: '<?',
            location: '<',
            onLocationChange: '&?',
            analyticsEventSource: '@?',
            analyticsEvent: '@?',
            showError: '<?',
            errorMessage: '<?',
            label: '<?'
        },
        controller: MeetingLocation,
        name: 'hbMeetingLocation',
        templateUrl: 'angular/app/modules/core/features/calendar/create_meeting_form/meeting_location/meeting_location_field.html'
    };
}());